import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

import { cn } from '@/lib/utils';
import { formatNumber, percentChange } from './format';

/**
 * A number with its change against the previous period, for table cells:
 * "2,266 ↗13%". No change shown from a zero baseline or when it rounds to 0.
 */
export function ValueWithChange({
  value,
  previous,
  title,
  className,
}: {
  value: number;
  previous: number;
  /** Hover text for the change, e.g. "vs previous 30 days". */
  title?: string;
  className?: string;
}) {
  const change = percentChange(value, previous);
  const shown = change !== null && Math.round(change) !== 0;
  return (
    <span className={cn('inline-flex items-center justify-end gap-1.5 tabular-nums', className)}>
      {formatNumber(value)}
      {shown && (
        <span className={cn('inline-flex items-center text-xs', change > 0 ? 'text-success' : 'text-destructive')} title={title}>
          {change > 0 ? <ArrowUpRight className="size-3" /> : <ArrowDownRight className="size-3" />}
          {Math.abs(Math.round(change))}%
        </span>
      )}
    </span>
  );
}
